"use client";

import Image from "next/image";
import { motion } from "framer-motion";
import { Quote, Linkedin } from "lucide-react";

export default function FounderQuote() {
  return (
    <motion.div
      className="h-full"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <div className="relative h-full rounded-2xl border border-white/5 bg-white/[0.02] p-8">
        <Quote className="absolute top-6 left-6 h-8 w-8 text-blue-500/20" />

        <div className="relative">
          <blockquote className="text-base leading-relaxed text-gray-300 lg:text-lg">
            &ldquo;Na jarenlange ervaring zagen we steeds hetzelfde: teams die te weinig oefenen en
            coaching die inconsistent is &mdash; afhankelijk van de trainer, het moment en het
            budget. Daarom hebben we CloserAI gebouwd: een compleet systeem van onboarding tot
            high-level skills, zodat elk teamlid dagelijks kan oefenen en meetbaar groeit. De
            resultaten in onze eigen bedrijven waren zo sterk dat we dit beschikbaar maken voor elke
            branche.&rdquo;
          </blockquote>

          <div className="mt-8 flex items-center gap-4">
            <div className="relative h-14 w-14 shrink-0">
              <Image
                src="/team-foto.jpg"
                alt="Mitchel & Maurice — Co-founders van CloserAI"
                width={112}
                height={112}
                className="h-14 w-14 rounded-full object-cover object-[center_20%] ring-2 ring-blue-500/30 ring-offset-2 ring-offset-[#030712]"
              />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="font-semibold text-white">Mitchel &amp; Maurice</span>
                <a
                  href="https://www.linkedin.com/in/mitchelvangerwen"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-5 w-5 items-center justify-center rounded bg-[#0A66C2] transition-opacity hover:opacity-80"
                  aria-label="Mitchel op LinkedIn"
                >
                  <Linkedin className="h-3 w-3 text-white" />
                </a>
                <a
                  href="https://www.linkedin.com/in/maurice-m-699a6a21b/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-5 w-5 items-center justify-center rounded bg-[#0A66C2] transition-opacity hover:opacity-80"
                  aria-label="Maurice op LinkedIn"
                >
                  <Linkedin className="h-3 w-3 text-white" />
                </a>
              </div>
              <div className="text-sm text-gray-500">
                <em>Co-founders</em>, CloserAI
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
